export class GridOptionModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class GridOption extends GridOptionModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
